import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import MembersForm from "@/v2/components/pages/members/Form";

export default function AddMember() {
    const [open, setOpen] = useState(false);
    return (
        <Dialog open={open} onOpenChange={(value) => setOpen(value)}>
            <DialogTrigger asChild>
                <Button>Add New Member</Button>
            </DialogTrigger>
            <DialogContent className="min-w-[600px]">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold tracking-tight">
                        Create new member
                    </DialogTitle>
                    <DialogDescription className="text-sm text-muted-foreground">
                        Fill in the details to create a new member
                    </DialogDescription>
                </DialogHeader>
                <MembersForm closeOnSave={() => setOpen(false)} />
            </DialogContent>
        </Dialog>
    );
}
